import Toastr from "../../itrust_common/components/Toastr"

const DEFAULT_STATE = {
  customer_leads: [],
  customer_lead: {},
  meta: { pagination: {} },
  saving: false
}
let changes = null
export default function demoRequestReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let demoRequests = [];
  let demoRequestData = [];
  let updatedRecord = {};
  switch (action.type) {
    case 'DEMO_REQUESTS_LOAD_PENDING':
    case 'DEMO_REQUEST_CREATE_PENDING':
      return { ...state, saving: true };

    case 'DEMO_REQUESTS_LOAD_REJECTED':
    case 'DEMO_REQUEST_CREATE_REJECTED':
    case 'DEMO_REQUEST_LOAD_REJECTED':
    case 'DEMO_REQUEST_UPDATE_REJECTED':
    case 'DEMO_REQUEST_DELETE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        saving: false
      }
      return { ...state, ...changes };
    case 'DEMO_REQUESTS_LOAD_FULFILLED':
      changes = {
        ...response,
        saving: false
      }
      return { ...state, ...changes }

    case 'DEMO_REQUEST_UPDATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      demoRequests = [...state.customer_leads];
      updatedRecord = response.customer_lead;
      for (const [index, customer_lead] of demoRequests.entries()) {
        if (customer_lead.id === updatedRecord.id) {
          demoRequestData = [
            ...demoRequests.slice(0, index),
            updatedRecord,
            ...demoRequests.slice(index + 1)
          ];
        }
      }
      changes = {
        customer_leads: demoRequestData,
        editing: false
      };
      return { ...state, ...changes };

    case 'DEMO_REQUEST_DELETE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      demoRequests = [...state.customer_leads];
      for (const [index, customer_lead] of demoRequests.entries()) {
        if (customer_lead.id === response.customer_lead.id) {
          demoRequests.splice(index, 1);
        }
      }
      return {
        ...state,
        customer_leads: demoRequests,
      };

    case 'DEMO_REQUEST_CREATE_FULFILLED':
      changes = {
        ...response,
        saving: false
      };
      return { ...state, ...changes };

    case 'DEMO_REQUEST_LOAD_FULFILLED':
      changes = {
        customer_lead: { ...response.customer_lead },
      };
      return { ...state, ...changes };
    case 'DEMO_REQUEST_EDIT':
      changes = {
        editing: action.payload
      };
      return { ...state, ...changes };

    case 'DEMO_REQUEST_EDIT_CANCEL':
      changes = {
        editing: false,
        customer_lead: {}
      };
      return { ...state, ...changes };

    default:
      return state
  }
}